import { graphql } from '@e-socna/data-layer';
import type { GenericStatusId } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

import { List } from './List';

export const UsersPage_ListForAStatus_SomeUsers_QueryDocument = graphql(`
  query UsersPage_ListForAStatus_SomeUsers_Query($statusId: Id!) {
    findSomeUsers(filter: { statusId: $statusId }) {
      ...UsersPage_List_User_Fragment
    }
  }
`);

interface Props {
  readonly statusId: GenericStatusId;
}

export const UsersListForAStatus = ({ statusId }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    UsersPage_ListForAStatus_SomeUsers_QueryDocument,
    { statusId },
    { enabled: !!statusId },
  );

  if (isSuccess) {
    const users = data.findSomeUsers;

    return <List users={users} />;
  }

  return <Loading />;
};
